'use es6';

import PropTypes from 'prop-types';
import { THIRD_PARTY_SERVICES } from '../constants/thirdPartyServices.constants';
const ActionContextPropType = PropTypes.arrayOf(PropTypes.oneOf([THIRD_PARTY_SERVICES.ZUORA, THIRD_PARTY_SERVICES.ADYEN]));
export default ActionContextPropType;